import React from "react";
import { createContext, useState } from "react";
import { Viewer } from "../viewer/main";
import { ProviderProps } from "./props";

export const ViewerContext = createContext({
  viewer: null as Viewer,
  setViewer: (value: any) => {}
});

export const ViewerProvider = (props: ProviderProps) => {
  const [viewer, setViewer] = useState(null);

  return (
    <ViewerContext.Provider value={{viewer, setViewer}}>
      {props.children}
    </ViewerContext.Provider>
  );
};